import { selectOffer } from './offerData';
import { IState } from '../store';
import { selectAgentLists } from './offerData/selectAgentLists';

export const selectIsAuctionBankObject = (state: IState) => {
  const { auctionBanks } = state;
  const { publishedUserId } = selectOffer(state);
  const agentLists = selectAgentLists(state);
  const isAuctionAgentLists = agentLists.includes('tradeRealty') || agentLists.includes('electronTradeSite');
  const isAuctionBanksLists = publishedUserId && auctionBanks.includes(publishedUserId);

  return isAuctionAgentLists || isAuctionBanksLists;
};
